export const texts = {
    text: 'מצטערים, העמוד שניסית להגיע אליו לא קיים...\n אבל תמיד אפשר לחזור לעמוד הבית',
    button: "לעמוד הבית"
}